import * as React from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import axios from "axios";
import * as go from "gojs";
import { ReactDiagram, ReactPalette } from "gojs-react";
import { geoFunc, colorFunc } from "../../../../_components/GojsGeostrings";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import {nodeDataArray, pipePalletNodeDataArray} from "./FxFlowGojs_Constants";
import {FxmsData} from "../../../datas/FxData";
import {TextField} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";

export const FxFlowGojsEditor = (props) => {
    const [nodeData, setNodeData] = useState([]);
    const [linkData, setLinkData] = useState([]);
    const [mode, setMode] = useState(true);
    const [svgTemplate, setSvgTemplate] = useState();
    const [pictureTemplate, setPictureTemplate] = useState();
    const [data, setData] = useState(2);
    const [model, setModel] = useState();
    const [bgimg, setBgimg] = useState("none");
    const [modelEnable, setModelEnable] = useState(true)
    const [canvasHeight, setCanvasHeight] = useState(500)
    const [linkStrokeColor, setLinkStrokeColor] = useState( 'yellow' )
    const [linkWidth, setLinkWidth] = useState(7 )
    const [linkLineColor, setLinkLineColor] = useState('red')
    const [linkLineWidth, setLinkLineWidth] = useState(5)
    const [animation, setAnimation] = useState(null);
    const [palletType, setPalletType] = useState(['pipe','plant','sensor']);
    const [selectedPallet, setSelectedPallet] = useState('')
    const [feFacDiag, setFeFacDiag] = useState({})
    const [selectedNode, setSelectedNode] = useState({})
    const [selectedNodeProps, setSelectedNodeProps] = useState({})
    const onChange = (e) => {
        //setSave({nodeDataArray:e.model.nodeDataArray,linkDataArray:e.model.linkDataArray})
    };
    useEffect(() => {
        FxmsData.GET('feFacPipe/ui/'+props.dashbNo).then(res=>{
            //res.data
            //feFacDiag : chgDtm, chgUserNo, diagNo, pipeId, regDtm, regUserNo
            //uiDiagLinkList : chgDtm, chgUserNo, diagNo, diagNodeNo, linkDiagNodeJson, linkDiagNodeNo1, linkDiagNodeNo2, regDtm, regUserNo
            //uiDiagNodeList : chgDtm, chgUserNo, diagNo, diagNodeAngle, diagNodeHeight, diagNodeJson, diagNodeKey, diagNodeNo, diagNodeText, diagNodeTypeCd, diagNodeWidth, diagNodeX, diagNodeY, regDtm, regUserNo
            let data = res.data
            data.uiDiagLinkList.map(x=>{
                x.from = x.linkDiagNodeNo1
                x.to = x.linkDiagNodeNo2
                x.key = x.diagNodeNo
            })
            data.uiDiagNodeList.map(x=>{
                x.icon = "pyrolysis"
                x.text = x.diagNodeKey
                x.color = "lightgreen"
                x.type = "building"
                x.moNo = ""
                x.category = "svg"
                x.value = ""
                x.key = x.diagNodeNo
                x.pos = "" + x.diagNodeX + " " + x.diagNodeY
            })
            //{"icon":"polymerization","text":"Polymers","color":"lightgreen","type":"building","moNo":999999,"category":"svg","value":11,"key":-6,"pos":"-497.5286865234375 145.10809326171875","__gohashid":23825}
            setNodeData(data.uiDiagNodeList)
            setLinkData(data.uiDiagLinkList)
            setFeFacDiag(data.feFacDiag)

        })
        // axios.get('http://175.123.142.155:11880/getPipe',{_id:props.dashbNo}).then(res=>{
        //     let data = res.data.filter(x=>x._id == props.dashbNo)[0]
        //     setBgimg(data.bgimg ? 'none':data.bgimg)
        //     setCanvasHeight(data.canvasHeight)
        //     // handleHeightChange({target:{value:data.canvasHeight}})
        //
        //     // handleLinkWidth({target:{value:data.linkWidth}})
        //     // handleLinkColor({target:{value:data.linkStrokeColor}})
        //     // handleLinkLineColor({target:{value:data.linkLineColor}})
        //     // handleLinkLineWidth({target:{value:data.lineWidth}})
        //     setLinkStrokeColor(data.linkStrokeColor ? data.linkStrokeColor : "#000000")
        //     setLinkWidth(data.linkWidth ?data.linkWidth : 10)
        //     setLinkLineColor(data.linkLineColor ? data.linkLineColor : "#707070")
        //     setLinkLineWidth(data.lineWidth ? data.lineWidth  : 10)
        //     setNodeData(data.nodeDataArray)
        //     setLinkData(data.linkDataArray)
        // })

    }, [model]);


    const makeButton = (text, action, visiblePredicate) =>{
        const $ = go.GraphObject.make;
        return $("ContextMenuButton",
            $(go.TextBlock, text),
            { click: action },
            // don't bother with binding GraphObject.visible if there's no predicate
            visiblePredicate ? new go.Binding("visible", "", (o, e) => o.diagram ? visiblePredicate(o, e) : false).ofObject() : {});
    }
    const handleNodeClick = (e,obj) => {
        setSelectedNode(obj.part.data)
    }
    const createTemplates = () =>{
        const $ = go.GraphObject.make;
        let svgTemplate = $(
            go.Node,
            "Spot",
            {
                click:(e,obj)=>handleNodeClick(e,obj),
                locationObjectName: "PORT",
                locationSpot: go.Spot.Top, // location point is the middle top of the PORT
                //linkConnected: updatePortHeight,
                //linkDisconnected: updatePortHeight,
                toolTip: $(
                    "ToolTip",
                    $(
                        go.TextBlock,
                        { margin: 4, width: 140 },
                        new go.Binding(
                            "text",
                            "",
                            (data) => data.text + ":\n\n" + data.description
                        )
                    )
                ),
            },
            new go.Binding("location", "pos", go.Point.parse).makeTwoWay(
                go.Point.stringify
            ),
            // The main element of the Spot panel is a vertical panel housing an optional icon,
            // plus a rectangle that acts as the port
            $(
                go.Panel,
                "Vertical",
                $(
                    go.TextBlock,
                    { name: "temp", text: "" },
                    new go.Binding("name", "key"),
                    new go.Binding("text", "value")
                ),

                $(
                    go.Shape,
                    {
                        width: 40,
                        height: 0,
                        stroke: "#fff7e3",
                        strokeWidth: 0.1,
                        fill: "#ffffff",
                    },
                    new go.Binding("height", "icon", () => 40),
                    new go.Binding("fill", "color", colorFunc),
                    new go.Binding("geometry", "icon", geoFunc)
                ),
                $(
                    go.Shape,
                    {
                        name: "PORT",
                        width: 40,
                        height: 12,
                        margin: new go.Margin(-1, 0, 0, 0),
                        stroke: "black",
                        strokeWidth: 1,
                        fill: "gray",
                        portId: "",
                        fromLinkable: true,
                        toLinkable: true,
                    },
                    new go.Binding("fill", "color", colorFunc)
                ),
                $(
                    go.TextBlock,
                    {
                        font: "Bold 14px Lato, sans-serif",
                        textAlign: "center",
                        margin: 3,
                        maxSize: new go.Size(100, NaN),
                        alignment: go.Spot.Top,
                        alignmentFocus: go.Spot.Bottom,
                        editable: true,
                        stroke: "white",
                    },
                    new go.Binding("text", "moNo").makeTwoWay()
                ),
                $(
                    go.TextBlock,
                    {
                        font: "Bold 14px Lato, sans-serif",
                        textAlign: "center",
                        margin: 3,
                        maxSize: new go.Size(100, NaN),
                        alignment: go.Spot.Top,
                        alignmentFocus: go.Spot.Bottom,
                        editable: true,
                        stroke: "white",
                    },
                    new go.Binding("text").makeTwoWay()
                )
            )
        );


        let pictureTemplate = $(
            go.Node,
            "Spot",
            { click:(e,obj)=>handleNodeClick(e,obj),locationObjectName: "PORT", locationSpot: go.Spot.Bottom },
            new go.Binding("location", "pos", go.Point.parse).makeTwoWay(
                go.Point.stringify
            ),
            $(
                go.Panel,
                "Vertical",
                $(
                    go.TextBlock,
                    { name: "temp", text: "" },
                    new go.Binding("name", "key"),
                    new go.Binding("text", "value")
                ),
                $(
                    go.Picture,
                    {
                        source: "thingspire.png",
                        portId: "",
                        width: 40,
                        height: 40,
                        fromLinkable: true,
                        toLinkable: true,
                    },
                    new go.Binding("source", "icon"),
                    new go.Binding("width", "width"),
                    new go.Binding("height", "height")
                ),
                $(
                    go.TextBlock,
                    {
                        font: "Bold 14px Lato, sans-serif",
                        textAlign: "center",
                        margin: 3,
                        maxSize: new go.Size(100, NaN),
                        alignment: go.Spot.Top,
                        alignmentFocus: go.Spot.Bottom,
                        editable: true,
                        stroke: "white",
                    },
                    new go.Binding("text", "moNo").makeTwoWay()
                ),
                $(
                    go.TextBlock,
                    {
                        font: "Bold 14px Lato, sans-serif",
                        textAlign: "center",
                        margin: 3,
                        maxSize: new go.Size(100, NaN),
                        alignment: go.Spot.Top,
                        alignmentFocus: go.Spot.Bottom,
                        editable: true,
                        stroke: "white",
                    },
                    new go.Binding("text").makeTwoWay()
                )
            )
        );

        // Show different kinds of port fittings by using different shapes in this Binding converter
        const portFigure =(pid) =>{
            if (pid === null || pid === "") return "XLine";
            if (pid[0] === 'F') return "CircleLine";
            if (pid[0] === 'M') return "PlusLine";
            return "XLine";  // including when the first character is 'U'
        }
        // Change the angle of the parts connected with the given node
        const rotate = (node, angle) =>{
            const tool = model.toolManager.draggingTool;  // should be a SnappingTool
            model.startTransaction("rotate " + angle.toString());
            const sel = new go.Set(/*go.Node*/);
            sel.add(node);
            const coll = tool.computeEffectiveCollection(sel).toKeySet();
            const bounds = model.computePartsBounds(coll);
            const center = bounds.center;
            coll.each(n => {
                n.angle += angle;
                n.location = n.location.copy().subtract(center).rotate(angle).add(center);
            });
            model.commitTransaction("rotate " + angle.toString());
        }
        function detachSelection() {
            model.startTransaction("detach");
            const coll = new go.Set(/*go.Link*/);
            model.selection.each(node => {
                if (!(node instanceof go.Node)) return;
                node.linksConnected.each(link => {
                    if (link.category !== "") return;  // ignore comments
                    // ignore links to other selected nodes
                    if (link.getOtherNode(node).isSelected) return;
                    // disconnect this link
                    coll.add(link);
                });
            });
            model.removeParts(coll, false);
            model.commitTransaction("detach");
        }

        // To simplify this code we define a function for creating a context menu button:
        function makeButton(text, action, visiblePredicate) {
            return $("ContextMenuButton",
                $(go.TextBlock, text),
                { click: action },
                // don't bother with binding GraphObject.visible if there's no predicate
                visiblePredicate ? new go.Binding("visible", "", (o, e) => o.diagram ? visiblePredicate(o, e) : false).ofObject() : {});
        }
        let pipeTemplate = $(go.Node, "Spot",
            {
                locationObjectName: "SHAPE",
                locationSpot: go.Spot.Center,
                selectionAdorned: false,  // use a Binding on the Shape.stroke to show selection
                itemTemplate:
                // each port is an "X" shape whose alignment spot and port ID are given by the item data
                    $(go.Panel,
                        new go.Binding("portId", "id"),
                        new go.Binding("alignment", "spot", go.Spot.parse),
                        $(go.Shape, "XLine",
                            { width: 0, height: 0, background: "transparent", fill: null, stroke: "gray" },
                            new go.Binding("figure", "id", portFigure),  // portFigure converter is defined below
                            new go.Binding("angle", "angle"))
                    ),
                // hide a port when it is connected
                linkConnected: (node, link, port) => {
                    if (link.category === "") {
                        port.visible = true;
                        link.visible = false;
                    }
                },
                linkDisconnected: (node, link, port) => {
                    if (link.category === ""){
                        port.visible = true;
                        link.visible = false;
                    }
                }
            },
            // this creates the variable number of ports for this Spot Panel, based on the data
            new go.Binding("itemArray", "ports"),
            // remember the location of this Node
            new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
            // remember the angle of this Node
            new go.Binding("angle", "angle").makeTwoWay(),
            // move a selected part into the Foreground layer, so it isn't obscured by any non-selected parts
            new go.Binding("layerName", "isSelected", s => s ? "Foreground" : "").ofObject(),
            $(go.Shape,
                {
                    name: "SHAPE",
                    // the following are default values;
                    // actual values may come from the node data object via data binding
                    geometryString: "F1 M0 0 L20 0 20 20 0 20 z",
                    fill: "rgba(128, 128, 128, 0.5)"
                },
                // this determines the actual shape of the Shape
                new go.Binding("geometryString", "geo"),
                // selection causes the stroke to be blue instead of black
                new go.Binding("stroke", "isSelected", s => s ? "dodgerblue" : "black").ofObject())
        );



        pipeTemplate.contextMenu = $("ContextMenu",
            makeButton("Rotate +45",
                (e, obj) => rotate(obj.part.adornedPart, 45)),
            makeButton("Rotate -45",
                (e, obj) => rotate(obj.part.adornedPart, -45)),
            makeButton("Rotate 180",
                (e, obj) => rotate(obj.part.adornedPart, 180)),
            makeButton("Detach",
                (e, obj) => detachSelection()),
            makeButton("Cut",
                (e, obj) => e.diagram.commandHandler.cutSelection(),
                o => o.diagram.commandHandler.canCutSelection()),
            makeButton("Copy",
                (e, obj) => e.diagram.commandHandler.copySelection(),
                o => o.diagram.commandHandler.canCopySelection()),
            makeButton("Paste",
                (e, obj) => e.diagram.commandHandler.pasteSelection(e.diagram.toolManager.contextMenuTool.mouseDownPoint),
                o => o.diagram.commandHandler.canPasteSelection(o.diagram.toolManager.contextMenuTool.mouseDownPoint)),
            makeButton("Delete",
                (e, obj) => e.diagram.commandHandler.deleteSelection(),
                o => o.diagram.commandHandler.canDeleteSelection()),
            makeButton("Undo",
                (e, obj) => e.diagram.commandHandler.undo(),
                o => o.diagram.commandHandler.canUndo()),
            makeButton("Redo",
                (e, obj) => e.diagram.commandHandler.redo(),
                o => o.diagram.commandHandler.canRedo())
        );


        return {svgTemplate,pictureTemplate,pipeTemplate}
    }
    const initDiagram = () => {
        const $ = go.GraphObject.make; // for conciseness in defining templates
        const myDiagram = $(
            go.Diagram, // create a Diagram for the DIV HTML element
            {
                "grid.visible": true,
                "grid.gridCellSize": new go.Size(20, 20),
                "draggingTool.isGridSnapEnabled": true,
                "resizingTool.isGridSnapEnabled": true,
                "rotatingTool.snapAngleMultiple": 90,
                "rotatingTool.snapAngleEpsilon": 45,
                "undoManager.isEnabled": true,
                // autoScrollRegion: 0,
                allowHorizontalScroll:false,
                allowVerticalScroll:false,
                allowZoom:true,
                "panningTool.isEnabled": true,
                "ModelChanged": e => {
                    if (e.isTransactionFinished) {handleModelChange() };

                }
                ,
                initialAutoScale: go.Diagram.Uniform, // scale to show all of the contents
                //ChangedSelection: onSelectionChanged, // view additional information
                maxSelectionCount: 1, // don't allow users to select more than one thing at a time
                isReadOnly: false,
                isEnabled : true,
                // "undoManager.isEnabled": true, // must be set to allow for model change listening
                // 'undoManager.maxHistoryLength': 0,  // uncomment disable undo/redo functionality
                //더블클릭시 신규노드가 생성되는 기능
                //'clickCreatingTool.archetypeNodeData': { text: 'new node', color: 'lightblue' },
                // "grid.visible": false,
                //"grid.gridCellSize": new go.Size(30, 20),
                //"draggingTool.isGridSnapEnabled": true,
                // "resizingTool.isGridSnapEnabled": false,
                // "rotatingTool.snapAngleMultiple": 90,
                // "rotatingTool.snapAngleEpsilon": 45,
                // "panningTool.isEnabled": false,
                model: new go.GraphLinksModel({
                    linkKeyProperty: "key", // IMPORTANT! must be defined for merges and data sync when using GraphLinksModel
                }),
                // ModelChanged: handleModelChange,
                //pipeline 용 속성들
                //드래그할때 자동으로 스내핑되는 툴, 배관아이콘 전용
                //draggingTool: new SnappingTool(),
                // contextMenu:
                //     $("ContextMenu",
                //         makeButton("Paste",
                //             (e, obj) => e.diagram.commandHandler.pasteSelection(e.diagram.toolManager.contextMenuTool.mouseDownPoint),
                //             o => o.diagram.commandHandler.canPasteSelection(o.diagram.toolManager.contextMenuTool.mouseDownPoint)),
                //         makeButton("Undo",
                //             (e, obj) => e.diagram.commandHandler.undo(),
                //             o => o.diagram.commandHandler.canUndo()),
                //         makeButton("Redo",
                //             (e, obj) => e.diagram.commandHandler.redo(),
                //             o => o.diagram.commandHandler.canRedo())
                //     ),
            }
        );
        myDiagram.linkTemplate = $(
            go.Link,
            {
                routing: go.Link.AvoidsNodes,
                curve: go.Link.JumpOver,
                layerName: "Background",
                // routing: go.Link.Orthogonal,
                corner: 15,
                reshapable: true,
                resegmentable: true,
                fromSpot: go.Spot.RightSide,
                toSpot: go.Spot.LeftSide,
            },
            // make sure links come in from the proper direction and go out appropriately
            new go.Binding("fromSpot", "fromSpot", go.Spot.parse),
            new go.Binding("toSpot", "toSpot", go.Spot.parse),
            new go.Binding("points").makeTwoWay(),
            // mark each Shape to get the link geometry with isPanelMain: true
            $(go.Shape, { isPanelMain: true, stroke: linkLineColor, strokeWidth: linkLineWidth,name:"PIPELINE" }),
            // get the default stroke color from the fromNode
            //new go.Binding("stroke", "fromNode", n => go.Brush.lighten((n && Colors[n.data.color]) || "gray")).ofObject(),
            // but use the link's data.color if it is set
            //new go.Binding("stroke", "color", colorFunc)),
            $(go.Shape, {
                isPanelMain: true,
                stroke: linkStrokeColor,
                strokeWidth: linkWidth,
                name: "PIPE",
                strokeDashArray: [20, 40],
            })
        );
        const temps = createTemplates()
        let templmap = new go.Map(); // In TypeScript you could write: new go.Map<string, go.Node>();
        // for each of the node categories, specify which template to use
        templmap.add("svg", temps.svgTemplate);
        templmap.add("picture", temps.pictureTemplate);
        templmap.add("pipeline",temps.pipeTemplate)
        // for the default category, "", use the same template that Diagrams use by default;
        // this just shows the key value as a simple TextBlock
        myDiagram.nodeTemplateMap = templmap;

        setModel(myDiagram);
        return myDiagram;
    };
    const updateAnimation = () => {
        if (animation) animation.stop();
        // Animate the flow in the pipes
        let ani = new go.Animation()
        ani.easing = go.Animation.EaseLinear;
        model.links.each(link => {
            ani.add(link.findObject("PIPE"), "strokeDashOffset", 60, 0)
        });
        // Run indefinitely
        ani.runCount = Infinity;
        ani.start();
        setAnimation(ani)
    }

    const palletPlantInit = () => {
        const $ = go.GraphObject.make; // for conciseness in defining templates
        const pallet = $(go.Palette, {
            //initialAutoScale: go.Diagram.Uniform, // scale to show all of the contents
            maxSelectionCount: 1, // don't allow users to select more than one thing at a time
        });
        const temps = createTemplates()
        let templmap = new go.Map(); // In TypeScript you could write: new go.Map<string, go.Node>();
        // for each of the node categories, specify which template to use
        templmap.add("svg", temps.svgTemplate);
        templmap.add("picture", temps.pictureTemplate);
        templmap.add("pipeline",temps.pipeTemplate)
        pallet.nodeTemplateMap = templmap;


        return pallet;
    };

    const palletPipeInit = () => {
        const temps = createTemplates()
        // Make sure the pipes are ordered by their key in the palette inventory
        const keyCompare = (a, b) =>{
            const at = a.data.key;
            const bt = b.data.key;
            if (at < bt) return -1;
            if (at > bt) return 1;
            return 0;
        }
        const $ = go.GraphObject.make; // for conciseness in defining templates
        const pallet = $(go.Palette, {
            initialScale: 1.2,
            contentAlignment: go.Spot.Center,
            "contextMenuTool.isEnabled": false,
            layout: $(go.GridLayout,
                { cellSize: new go.Size(1, 1), spacing: new go.Size(5, 5), comparer: keyCompare }),
            // initialize the Palette with a few "pipe" nodes
            model: new go.GraphLinksModel({
                copiesArrays: true,
                copiesArrayObjects: true,
                linkFromPortIdProperty: "fid",
                linkToPortIdProperty: "tid",
                nodeDataArray: pipePalletNodeDataArray
            })
        });
        let templmap = new go.Map(); // In TypeScript you could write: new go.Map<string, go.Node>();
        // for each of the node categories, specify which template to use

        templmap.add("pipeline",temps.pipeTemplate)
        pallet.nodeTemplateMap = templmap;
        return pallet
    }
    const updatePortHeight = (node, link, port) => {
        let sideinputs = 0;
        let sideoutputs = 0;
        node.findLinksConnected().each((l) => {
            if (l.toNode === node && l.toSpot === go.Spot.LeftSide) sideinputs++;
            if (l.fromNode === node && l.fromSpot === go.Spot.RightSide)
                sideoutputs++;
        });
        let tot = Math.max(sideinputs, sideoutputs);
        tot = Math.max(1, Math.min(tot, 2));
        port.height = tot * (10 + 2) + 2; // where 10 is the link path's strokeWidth
    };


    const updateData = () => {
        model.startTransaction();
        model.nodes.each(function (node) {
            console.log(data);
            model.model.setDataProperty(node.data, "value", data);
        });
        model.commitTransaction("modified Graduated Panel");
    };

    const saveData = () => {
        //db save
        let smallLinkData = model.model.linkDataArray
        smallLinkData.map(x=>{
            x.points = ''
        })
        let uiNodeList = model.model.nodeDataArray
        console.log(uiNodeList)
        //chgDtm, chgUserNo, diagNo, diagNodeAngle, diagNodeHeight, diagNodeJson, diagNodeKey, diagNodeNo, diagNodeText, diagNodeTypeCd, diagNodeWidth, diagNodeX, diagNodeY, regDtm, regUserNo
        uiNodeList.map(x=>{
            x.diagNodeX = x.pos.split(" ")[0]
            x.diagNodeY = x.pos.split(" ")[1]
        })
        let uiLinkList = model.model.linkDataArray
        console.log(uiLinkList)
        uiLinkList.map(x=>{
            x.linkDiagNodeNo1 = x.from
            x.linkDiagNodeNo2 = x.to
        })
        let currentData = {}
        currentData.pipeId = props.dashbNo
        currentData.uiDiagNodeList = uiNodeList
        currentData.uiDiagLinkList = uiLinkList
        currentData.feFacDiag = feFacDiag
        console.log(currentData)
        FxmsData.POST('/feFacPipe/ui',currentData).then(res=>{
            console.log(res)
        })
        // let currentData = []
        // currentData.push({uiNo:props.item.uiNo,attrName:'bgimg',attrVal:bgimg,attrType:'string'})
        // currentData.push({uiNo:props.item.uiNo,attrName:'nodeDataArray',attrVal:JSON.stringify(model.model.nodeDataArray),attrType:'string'})
        // currentData.push({uiNo:props.item.uiNo,attrName:'linkDataArray',attrVal:JSON.stringify(smallLinkData),attrType:'string'})
        // currentData.push({uiNo:props.item.uiNo,attrName:'canvasHeight',attrVal:canvasHeight,attrType:'string'})
        // currentData.push({uiNo:props.item.uiNo,attrName:'linkStrokeColor',attrVal:linkStrokeColor,attrType:'string'})
        // currentData.push({uiNo:props.item.uiNo,attrName:'linkWidth',attrVal:linkWidth,attrType:'string'})
        // currentData.push({uiNo:props.item.uiNo,attrName:'linkLineColor',attrVal:linkLineColor,attrType:'string'})
        // currentData.push({uiNo:props.item.uiNo,attrName:'linkLineWidth',attrVal:linkLineWidth,attrType:'string'})

        // axios.get('http://175.123.142.155:11880/getPipe').then(res=>{
        //     let data = res.data.filter(x=>x._id == props.dashbNo)[0]
        //     let currentData = {
        //         _id:props.dashbNo,
        //         bgimg,
        //         nodeDataArray:model.model.nodeDataArray,
        //         linkDataArray:model.model.linkDataArray,
        //         canvasHeight,
        //         linkStrokeColor,
        //         linkWidth,
        //         linkLineColor,
        //         linkLineWidth,
        //         dashbViewUgrpList : data.dashbViewUgrpList,
        //         dashbEditUgrpList : data.dashbEditUgrpList,
        //         useYn : data.useYn,
        //         dashbName : data.dashbName,
        //         dashbdescr : data.dashbdescr
        //     }
        //     axios.put('http://175.123.142.155:11880/updatePipe',currentData)
        // })

        //props.save(currentData,props.item.uiNo,props.item.opId)
    };
    const handleModelChange = (e) =>{
        if(model){
            updateAnimation()
            model.zoomToFit()
            model.links.each(link => {
                let shape = link.findObject("PIPE");
                shape.stroke = linkStrokeColor
                shape.strokeWidth = linkWidth
                let shape2 = link.findObject("PIPELINE");
                shape2.stroke = linkLineColor
                shape2.strokeWidth = linkLineWidth
            });
        }
    }
    //edit mode
    const display = () => {
        // gojs logo 처리
        // const canvas = document.getElementsByClassName("main")[0].firstChild
        // const context = canvas.getContext('2d');
        // context.clearRect(0, 0, 180, 70);
        // context.save()
        model.isEnabled=!model.isEnabled
        let status = !modelEnable
        setModelEnable(status)

    }
    const handleHeightChange = (e) => {
        setCanvasHeight(e.target.value)
    }
    const handleLinkColor = (e) => {
        setLinkStrokeColor(e.target.value)
        model.links.each(link => {
            let shape = link.findObject("PIPE");
            shape.stroke = e.target.value
        });
    }
    const handleLinkWidth = (e) => {
        setLinkWidth(e.target.value)
        model.links.each(link => {
            let shape = link.findObject("PIPE");
            shape.strokeWidth = e.target.value
        });
    }
    const handleLinkLineColor = (e) => {
        setLinkLineColor(e.target.value)
        model.links.each(link => {
            let shape = link.findObject("PIPELINE");
            shape.stroke = e.target.value
        });
    }
    const handleLinkLineWidth = (e) => {
        setLinkLineWidth(e.target.value)
        model.links.each(link => {
            let shape = link.findObject("PIPELINE");
            shape.strokeWidth = e.target.value
        });
    }
    const removeItem = () => {
        setNodeData([])
        setLinkData([])
    }
    return (
        <StyledEngineProvider injectFirst>
            <div>
                <div>
                    {props.editable ?
                        <>
                            <Button variant={"contained"} onClick={saveData} style={{ margin: "10px" }}>save</Button>
                            <Button variant={"contained"} onClick={display} style={{ margin: "10px" }}>{modelEnable?'edit':'disp'}</Button>
                            <TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"canvas size"} variant={"outlined"} onChange={handleHeightChange} defaultValue={300}></TextField>
                            <FormControl style={{ margin: "10px" }} size={"small"}>
                                <InputLabel >배경그림</InputLabel>
                                <Select
                                    sx={{color: "white", '.MuiOutlinedInput-notchedOutline': {color:'white',borderColor: 'rgba(243,232,248,0.82)',},
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                        '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                        '.MuiSvgIcon-root ': {fill: "white !important",}
                                    }}
                                    label={"kldsjkl"}
                                    value={bgimg}
                                    onChange={(e) => setBgimg(e.target.value)}
                                    placeholder={"이미지선택"}
                                >
                                    <MenuItem sx={{color:'white'}} value={"none"}>
                                        {"없음"}
                                    </MenuItem>
                                    <MenuItem sx={{color:'white'}} value={"flarestack_bg.jpg"}>
                                        {"flarestack_bg.jpg"}
                                    </MenuItem>
                                    <MenuItem sx={{color:'white'}} value={"dashboard_guide.png"}>
                                        {"dashboard_guide.png"}
                                    </MenuItem>
                                    <MenuItem sx={{color:'white'}} value={"things.png"}>{"things.png"}</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"dash color"} type="color" value={linkStrokeColor} onChange={handleLinkColor}   />
                            <TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"dash size"} variant={"outlined"} onChange={handleLinkWidth} defaultValue={linkWidth} ></TextField>
                            <TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"line color"} type="color" value={linkLineColor} onChange={handleLinkLineColor} />
                            <TextField sx={{input:{color:'white'},width:'100px', margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}} label={"line size"} variant={"outlined"} onChange={handleLinkLineWidth} defaultValue={linkLineWidth} ></TextField>
                            <IconButton size={'small'} sx={{minWidth:0, right:'5px',position:'absolute',zIndex:999}} onClick={removeItem}>
                                <DeleteIcon/>
                            </IconButton>
                        </> : ''}

                </div>

                <ReactDiagram
                    style={{
                        minHeight: canvasHeight+"px",
                        backgroundImage: bgimg=="none"?"none":"url(" + bgimg + ")",
                        backgroundSize: "cover",
                    }}
                    initDiagram={initDiagram}
                    divClassName="main"
                    nodeDataArray={nodeData}
                    linkDataArray={linkData}
                    onModelChange={handleModelChange}
                />
                {Object.keys(selectedNode).length > 0 ?
                    <div>
                        <FormControl fullWidth >
                            <InputLabel >아이콘 유형 선택</InputLabel>
                           <Select
                                sx={{minWidth:'100px',color: "white", '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}
                                }}
                                defaultValue={''}
                                // value={selectedNodeProps.icon}
                                onChange={(e)=>{
                                    let uiNodeList = [...model.model.nodeDataArray]
                                    //chgDtm, chgUserNo, diagNo, diagNodeAngle, diagNodeHeight, diagNodeJson, diagNodeKey, diagNodeNo, diagNodeText, diagNodeTypeCd, diagNodeWidth, diagNodeX, diagNodeY, regDtm, regUserNo
                                    uiNodeList.map(x=>{
                                        if(x.diagNodeKey == selectedNode.diagNodeKey){
                                            x.icon = e.target.value.split("|")[0]
                                            x.category = e.target.value.split("|")[1]
                                            console.log(x)
                                        }
                                    })
                                    // model.model.commit(m=>{
                                    //     m.set(m.nodeDataArray.find(x=>x.diagNodeKey==selectedNode.diagNodeKey),"type",e.target.value.split("|")[1])
                                    // },"change")
                                    setNodeData([])
                                    setTimeout(() => {setNodeData(uiNodeList)}, 100);


                                }}

                                >
                                    <MenuItem className="dashboard_admin_select"   value={''}>아이콘유형 선택</MenuItem>
                                {nodeDataArray.map((x,index) => (
                                    <MenuItem className="dashboard_admin_select"   key={index} value={x.icon+"|"+x.category}>{x.icon}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                :''}
                {/*{props.editable || modelEnable ? <ReactPalette*/}
                {/*    style={{ minHeight: "200px" }}*/}
                {/*    initPalette={palletPlantInit}*/}
                {/*    divClassName="myPaletteDiv"*/}
                {/*    nodeDataArray={nodeDataArray}*/}
                {/*/> : ''}*/}

                {/*{props.editable || modelEnable ? <ReactPalette*/}
                {/*    style={{ minHeight: "200px" }}*/}
                {/*    initPalette={palletPipeInit}*/}
                {/*    divClassName="myPaletteDiv"*/}
                {/*    nodeDataArray={pipePalletNodeDataArray}*/}

                {/*/> : '' }*/}
            </div>
        </StyledEngineProvider>
    );
};

// Define a custom DraggingTool
class SnappingTool extends go.DraggingTool {
    // This predicate checks to see if the ports can snap together.
    // The first letter of the port id should be "U", "F", or "M" to indicate which kinds of port may connect.
    // The second letter of the port id should be a digit to indicate which direction it may connect.
    // The ports also need to not already have any link connections and need to face opposite directions.
    compatiblePorts(p1, p2) {
        // already connected?
        const part1 = p1.part;
        const id1 = p1.portId;
        if (id1 === null || id1 === "") return false;
        if (part1.findLinksConnected(id1).filter(l => l.category === "").count > 0) return false;
        const part2 = p2.part;
        const id2 = p2.portId;
        if (id2 === null || id2 === "") return false;
        if (part2.findLinksConnected(id2).filter(l => l.category === "").count > 0) return false;
        // compatible fittings?
        if ((id1[0] === 'U' && id2[0] === 'U') ||
            (id1[0] === 'F' && id2[0] === 'M') ||
            (id1[0] === 'M' && id2[0] === 'F')) {
            // find their effective sides, after rotation
            const a1 = this.effectiveAngle(id1, part1.angle);
            const a2 = this.effectiveAngle(id2, part2.angle);
            // are they in opposite directions?
            if (a1 - a2 === 180 || a1 - a2 === -180) return true;
        }
        return false;
    }

    // At what angle can a port connect, adjusting for the node's rotation
    effectiveAngle(id, angle) {
        const dir = id[1];
        let a = 0;
        if (dir === '1') a = 45;
        else if (dir === '2') a = 90;
        else if (dir === '3') a = 135;
        else if (dir === '4') a = 180;
        else if (dir === '5') a = 225;
        else if (dir === '6') a = 270;
        else if (dir === '7') a = 315;
        a += angle;
        if (a < 0) a += 360;
        else if (a >= 360) a -= 360;
        return a;
    }

    // Override this method to find the offset such that a moving port can
    // be snapped to be coincident with a compatible stationary port,
    // then move all of the parts by that offset.
    moveParts(parts, offset, check) {
        // when moving an actually copied collection of Parts, use the offset that was calculated during the drag
        if (this._snapOffset && this.isActive && this.diagram.lastInput.up && parts === this.copiedParts) {
            super.moveParts(parts, this._snapOffset, check);
            this._snapOffset = undefined;
            return;
        }

        let commonOffset = offset;

        // find out if any snapping is desired for any Node being dragged
        const sit = parts.iterator;
        while (sit.next()) {
            const node = sit.key;
            if (!(node instanceof go.Node)) continue;
            const info = sit.value;
            const newloc = info.point.copy().add(offset);

            // now calculate snap point for this Node
            const snapoffset = newloc.copy().subtract(node.location);
            let nearbyports = null;
            let closestDistance = 20 * 20;  // don't bother taking sqrt
            let closestPort = null;
            let closestPortPt = null;
            let nodePort = null;
            const mit = node.ports;
            while (mit.next()) {
                const port = mit.value;
                if (node.findLinksConnected(port.portId).filter(l => l.category === "").count > 0) continue;
                const portPt = port.getDocumentPoint(go.Spot.Center);
                portPt.add(snapoffset);  // where it would be without snapping

                if (nearbyports === null) {
                    // this collects the Nodes that intersect with the NODE's bounds,
                    // excluding nodes that are being dragged (i.e. in the PARTS collection)
                    const nearbyparts = this.diagram.findObjectsIn(node.actualBounds,
                        x => x.part,
                        p => !parts.has(p),
                        true);

                    // gather a collection of GraphObjects that are stationary "ports" for this NODE
                    nearbyports = new go.Set(/*go.GraphObject*/);
                    nearbyparts.each(n => {
                        if (n instanceof go.Node) {
                            nearbyports.addAll(n.ports);
                        }
                    });
                }

                const pit = nearbyports.iterator;
                while (pit.next()) {
                    const p = pit.value;
                    if (!this.compatiblePorts(port, p)) continue;
                    const ppt = p.getDocumentPoint(go.Spot.Center);
                    const d = ppt.distanceSquaredPoint(portPt);
                    if (d < closestDistance) {
                        closestDistance = d;
                        closestPort = p;
                        closestPortPt = ppt;
                        nodePort = port;
                    }
                }
            }

            // found something to snap to!
            if (closestPort !== null) {
                // move the node so that the compatible ports coincide
                const noderelpt = nodePort.getDocumentPoint(go.Spot.Center).subtract(node.location);
                const snappt = closestPortPt.copy().subtract(noderelpt);
                // save the offset, to ensure everything moves together
                commonOffset = snappt.subtract(newloc).add(offset);
                // ignore any node.dragComputation function
                // ignore any node.minLocation and node.maxLocation
                break;
            }
        }

        // now do the standard movement with the single (perhaps snapped) offset
        this._snapOffset = commonOffset.copy();  // remember for mouse-up when copying
        super.moveParts(parts, commonOffset, check);
    }

    // Establish links between snapped ports,
    // and remove obsolete links because their ports are no longer coincident.
    doDropOnto(pt, obj) {
        super.doDropOnto(pt, obj);
        // Need to iterate over all of the dropped nodes to see which ports happen to be snapped to stationary ports
        const coll = this.copiedParts || this.draggedParts;
        const it = coll.iterator;
        while (it.next()) {
            const node = it.key;
            if (!(node instanceof go.Node)) continue;
            // connect all snapped ports of this NODE (yes, there might be more than one) with links
            const pit = node.ports;
            while (pit.next()) {
                const port = pit.value;
                // maybe add a link -- see if the port is at another port that is compatible
                const portPt = port.getDocumentPoint(go.Spot.Center);
                if (!portPt.isReal()) continue;
                const nearbyports =
                    this.diagram.findObjectsAt(portPt,
                        x => {  // some GraphObject at portPt
                            let o = x;
                            // walk up the chain of panels
                            while (o !== null && o.portId === null) o = o.panel;
                            return o;
                        },
                        p => {  // a "port" Panel
                            // the parent Node must not be in the dragged collection, and
                            // this port P must be compatible with the NODE's PORT
                            if (coll.has(p.part)) return false;
                            const ppt = p.getDocumentPoint(go.Spot.Center);
                            if (portPt.distanceSquaredPoint(ppt) >= 0.25) return false;
                            return this.compatiblePorts(port, p);
                        });
                // did we find a compatible port?
                const np = nearbyports.first();
                if (np !== null) {
                    // connect the NODE's PORT with the other port found at the same point
                    this.diagram.toolManager.linkingTool.insertLink(node, port, np.part, np);
                }
            }
        }
    }

    // Just move selected nodes when SHIFT moving, causing nodes to be unsnapped.
    // When SHIFTing, must disconnect all links that connect with nodes not being dragged.
    // Without SHIFT, move all nodes that are snapped to selected nodes, even indirectly.
    computeEffectiveCollection(parts) {
        if (this.diagram.lastInput.shift) {
            const links = new go.Set(/*go.Link*/);
            const coll = super.computeEffectiveCollection(parts);
            coll.iteratorKeys.each(node => {
                // disconnect all links of this node that connect with stationary node
                if (!(node instanceof go.Node)) return;
                node.findLinksConnected().each(link => {
                    if (link.category !== "") return;
                    // see if this link connects with a node that is being dragged
                    const othernode = link.getOtherNode(node);
                    if (othernode !== null && !coll.has(othernode)) {
                        links.add(link);  // remember for later deletion
                    }
                });
            });
            // outside of nested loops we can actually delete the links
            links.each(l => l.diagram.remove(l));
            return coll;
        } else {
            const map = new go.Map(/*go.Part, Object*/);
            if (parts === null) return map;
            parts.iterator.each(n => this.gatherConnecteds(map, n));
            return map;
        }
    }

    // Find other attached nodes.
    gatherConnecteds(map, node) {
        if (!(node instanceof go.Node)) return;
        if (map.has(node)) return;
        // record the original Node location, for relative positioning and for cancellation
        map.add(node, new go.DraggingInfo(node.location));
        // now recursively collect all connected Nodes and the Links to them
        node.findLinksConnected().each(link => {
            if (link.category !== "") return;  // ignore comment links
            map.add(link, new go.DraggingInfo());
            this.gatherConnecteds(map, link.getOtherNode(node));
        });
    }
}
// end SnappingTool class